import { Link as RRLink } from 'react-router-dom'
import styled from 'styled-components'

export const Link = styled(RRLink)`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: -0.004em;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.Violet};
`
